export const cssBEM = 'cardBuilder';